<template>
    <el-dialog id="updateCsvTable"
        :title="importTitle" 
        :visible.sync="dialogVisible"
        :before-close="handleClose">
        <input v-show="false" type="file" name="File Upload" ref="csvFile" accept=".csv" v-on:change="handleFilesUpload()"/>
        <el-button v-show="csvFile.length === 0" class="choose-btn" @click="chooseCSV">選擇檔案</el-button>
        <!-- CSV table -->
        <el-table v-if="!importStart && csvFile && csvFile.length > 0"
            :data="csvFile" empty-text="暫無資料" style="width: 100%">
            <el-table-column min-width="90" prop="name" label="原工號">
            </el-table-column>
            <el-table-column label="姓名" prop="displayname" min-width="90">
            </el-table-column>
            <el-table-column label="新工號" min-width="90">
                <editable-cell slot-scope="{row}" :can-edit="true" v-model="row.new_id">
                    <span slot="content">{{row.new_id}}</span>
                </editable-cell>
            </el-table-column>
            <el-table-column label="Email" min-width="150">
                <editable-cell slot-scope="{row}" :can-edit="true" v-model="row.email">
                    <span slot="content">{{row.email}}</span>
                </editable-cell>
            </el-table-column>
            <el-table-column label="Level" min-width="100">
                <editable-cell slot-scope="{row}" :can-edit="true" v-model="row.level"
                    editable-component="el-select" align="center" close-event="change">	
                    <el-tag size="medium" slot="content">
                        {{formatLevel(row)}}
                    </el-tag>
                    <template slot="edit-component-slot">
                        <el-option value="1" label="Level 1"></el-option>
                        <el-option value="2" label="Level 2"></el-option>
                        <el-option value="3" label="Level 3"></el-option>
                    </template>
                </editable-cell>
            </el-table-column>
            <el-table-column v-if="$store.state.isSystemAdminMode" label="Department" min-width="150">
                <el-cascader placeholder="請選擇"
                        slot-scope="{row}" 
                        v-model="row.selectedDepId"
                        :show-all-levels="false"
                        :options="actualDepsOptions">
                </el-cascader>
            </el-table-column>
        </el-table>
        <span slot="footer" class="dialog-footer">
            <div v-show="!importStart && csvFile && csvFile.length > 0 && !csvTrasfer"
                    class="csv-hint">載入csv後中文字出現亂碼嗎 ? 請點擊「UTF8編碼轉換」按鈕後再繼續執行編輯動作或參閱
            </div>
            <a v-show="!importStart && csvFile && csvFile.length > 0 && !csvTrasfer"
                    class="download-csv-hint"
                    href="./static/CSV_UTF8_Format.pdf"
                    download="CSV_UTF8_Format.pdf">csv格式轉檔說明
            </a>
            <div v-show="!importStart && csvFile && csvFile.length > 0" class="btn-area">
                <el-button class="import-btn" @click="importCSV">
                    確定匯入
                </el-button>
                <el-button class="renew-btn" @click="chooseCSV">
                    重新選擇
                </el-button>
                <el-button v-show="!csvTrasfer" class="utf8-btn" @click="utf8CSV">
                    UTF8編碼轉換
                </el-button>
                <el-button v-show="csvTrasfer" class="utf8-btn" @click="big5CSV">
                    BIG5編碼轉換
                </el-button>
            </div>
            <el-progress v-show="importStart" :percentage="importPercent"></el-progress>
        </span>
    </el-dialog>
</template>

<script>
import API from '../../api/api';
import EditableCell from "./EditeableCell.vue";
export default {
    name: 'AccountUpdate',
    components: {
        EditableCell,
    },
    props: {
        actualDepsOptions: {
            type: Array
        },
        updateCsvArray: {
            type: Array
        },
    },
    data() {
        return {
            dialogVisible: false,
            csvFile: [],
            importTitle: "批次修改帳號",
            importPercent: 0,
            importStart: false,
            csvTrasfer: false,
            sourceRef: null
        }
    },
    methods: {
        startUpdate() {
            this.dialogVisible = true;
            this.csvFile.splice(0);
            this.csvFile = this.updateCsvArray;
            this.updateDialog();
        },
        updateDialog() {
            if (this.csvFile && this.csvFile.length > 0 ) {
                this.importTitle = "批次修改帳號" + " - 成功載入 " + this.csvFile.length  + " 筆資料";
                document.getElementById('updateCsvTable').children[0].style.width = "900px";
            } else {
                this.$emit("showHint", '批次修改帳號 CSV 裡沒有資料，請重新選擇檔案進行匯入!');
                this.importTitle = "批次修改帳號";
                document.getElementById('updateCsvTable').children[0].style.width = "520px";
                $('input[type="file"]').val(null);
            }
        },
        handleClose: function() {
            this.$confirm('確定結束批次修改動作嗎 ?', '提示', {
                confirmButtonText: '確定',
                cancelButtonText: '取消',
            }).then(() => {
                this.setImportantProgress(0, "批次修改帳號", false);
                this.dialogVisible = false;
                $('input[type="file"]').val(null);
                this.csvFile = [];
            }).catch(() => {

            });
        },
        setImportantProgress: function(percent, title, isGoing) {
            this.importPercent = percent;
            this.importTitle = title;
            this.importStart = isGoing;
        },
        handleFilesUpload: function() {
            this.csvTrasfer = false;
            if(this.$refs.csvFile.files[0]) {
                this.sourceRef = this.$refs.csvFile.files[0];
                this.fileReader(false, this.sourceRef);
            } 
        },
        chooseCSV: function(evt) {
            this.$refs.csvFile.click();
        },
        utf8CSV: function(evt) {
            this.$confirm('將以一開始載入的資料作轉換，確定要繼續轉換？ ?', '提示', {
                confirmButtonText: '確定',
                cancelButtonText: '取消',
            }).then(() => {
                this.fileReader(true, this.sourceRef);
            }).catch(() => {

            });
        },
        big5CSV: function(evt) {
            this.$confirm('將以一開始載入的資料作轉換，確定要繼續轉換？ ?', '提示', {
                confirmButtonText: '確定',
                cancelButtonText: '取消',
            }).then(() => {
                this.fileReader(false, this.sourceRef);
            }).catch(() => {

            });
        },
        fileReader: function(utf8, file) {
            var reader = new FileReader();
            let that = this;
    
            if(utf8) {
                reader.readAsText(file);
                that.csvTrasfer = true;
            } else {
                reader.readAsText(file, 'big5');
                that.csvTrasfer = false;
            }
            
            reader.onload = function(event) {
                that.csvFile = window.jQuery.csv.toObjects(event.target.result);
                that.csvFile.forEach((obj) => {
                    that.renameKey(obj, '原工號', 'name');
                    that.renameKey(obj, '新工號', 'new_id');
                    that.renameKey(obj, '姓名', 'displayname');
                    that.renameKey(obj, 'e-Mail', 'email');
                    that.renameKey(obj, 'Level', 'level');
                });
        
                //CSV基本防呆判斷
                if (that.csvFile && that.csvFile.length > 0 ) {
                    that.importTitle = "匯入帳號" + " - 成功載入 " + that.csvFile.length  + " 筆資料";
                    document.getElementById('updateCsvTable').children[0].style.width = "800px";
                } else {
                    that.$emit("showHint", '匯入帳號 CSV 裡沒有資料，請重新選擇檔案進行匯入!');
                    that.importTitle = "匯入帳號";
                    document.getElementById('updateCsvTable').children[0].style.width = "520px";
                    $('input[type="file"]').val(null);
                }
            };
    
            reader.onerror = function() {
                that.$emit("showHint", '匯入帳號 CSV 錯誤!');
            };
        },
        importCSV() {
            this.setImportantProgress(0, "匯入帳號 - 檢查中...", true);

            // check duplicate new id 
            let new_idArray = this.csvFile.map(obj => obj.new_id);
            let duplicate = new_idArray.reduce(function(acc, el, i, arr) {
                if (arr.indexOf(el) !== i && acc.indexOf(el) < 0) acc.push(el); return acc;
            }, []);
            if (duplicate.length > 0) {
                let hint = '';
                for(let i = 0 ; i < duplicate.length ; i++) {
                    hint += duplicate[i] + '  '
                }
                this.importTitle = "匯入帳號 - 檢查發現錯誤（注意: 新帳號 " +  hint + " 重複使用)";
                return;
            }

            this.import();
        },
        async import() {
            this.setImportantProgress(0, "匯入帳號 - 匯入中...", true);
            let existError = [];
            let availableError = [];
            let commonError = [];
            let isError = false;
            for(let i = 0 ; i < this.csvFile.length ; i++) {
                // check name exist
                await API.accountCheck(this.csvFile[i].name).then(
                    (response) => {
                        if (response === 0) {
                            existError.push(this.csvFile[i].name);
                            isError = true;
                        }
                    }
                );
                if (isError) {
                    isError = false;
                    continue;
                }

                // check new id available
                if (this.csvFile[i].name !== this.csvFile[i].new_id) {
                    await API.accountCheck(this.csvFile[i].new_id).then(
                        (response) => {
                            if (response === 1) {
                                availableError.push(this.csvFile[i].new_id);
                                isError = true;
                            }
                        }
                    );

                    if (isError) {
                        isError = false;
                        continue;
                    }
                }
                
                let obj = {
                    name: this.csvFile[i].name,
                    new_name: this.csvFile[i].new_id,
                    email: this.csvFile[i].email,
                    actual_depid: this.csvFile[i].selectedDepId[1],
                    level: this.csvFile[i].level,
                }
                await API.accountSpinoff(obj).then(
                    (response) => {
                        let progress = Math.floor(100 / (this.csvFile.length) * (i+1));
                        this.setImportantProgress(progress, "匯入帳號 - 匯入中...", true);
                        if(response.status) {
                            console.log(response);
                            this.$emit("showHint", JSON.parse(response.request.response).error_msg);
                            commonError.push(this.csvFile[i].name);
                            isError = true;
                        }
                    }
                );

                if (isError) {
                    isError = false;
                }
            }

            if (existError.length === 0 && availableError.length === 0 && commonError.length === 0) {
                this.importTitle = "匯入帳號 - 匯入完成（請關閉視窗)";
            } else {
                let errorHint = "匯入帳號 - 匯入發現錯誤(";

                if (existError.length > 0) {
                    errorHint += '原工號 ';
                    for(let i = 0 ; i < existError.length ; i++) {
                        errorHint += existError[i] + '  '
                    }
                    errorHint += '不存在。';
                }

                if (availableError.length > 0) {
                    errorHint += '新工號 ';
                    for(let i = 0 ; i < availableError.length ; i++) {
                        errorHint += availableError[i] + '  '
                    }
                    errorHint += '已存在。';
                }

                 if (commonError.length > 0) {
                    errorHint += '原工號 '
                    for(let i = 0 ; i < commonError.length ; i++) {
                        errorHint += commonError[i] + '  '
                    }
                    errorHint += '匯入發生錯誤。';
                 }
                 errorHint += ')';
                this.importTitle = errorHint;
            }
            this.$emit("getAccounts");
        },
        formatLevel: function (row, column) {
            return 'Level ' + row.level;
        },
        renameKey(obj, oldKey, newKey) {
            obj[newKey] = obj[oldKey];
            delete obj[oldKey];
        },
    },
}
</script>
<style lang="scss">
    .choose-hint {
        display: block;
        width: 100%;
        float: left;
    }
    .download-hint {
        display: block;
        float: left;
        color: #2E90F4;
        border-bottom: 1px solid #42A0FF;
        margin-bottom: 25px;
        cursor: pointer;
    }
    .csv-hint {
        display: block;
        float: left;
        color: #2E90F4;
        margin-bottom: 25px;
    }
    .download-csv-hint {
        display: block;
        float: left;
        color:red;
        border-bottom: 1px solid red;
        margin-bottom: 25px;
        cursor: pointer;
    }
    .download-csv-hint:hover {
        color:red;
    }

    .choose-btn {
		display: block;
		background: #fff;
		border-radius: 2px;
		color: #2E90F4;
		font-size: 14px;
		height: 36px;
		margin-top: 30px;
		border: 1px solid #2E90F4;
		width: 92px;
	}	
	.choose-btn:hover {
		border: 1px solid #42A0FF;
	}

	.btn-area {
		display: block;
		float: right;
		.renew-btn {
			background: #2E90F4;
			float: right;
			border-radius: 2px;
			color: #fff;
			font-size: 14px;
			height: 36px;
			margin: 20px 20px 20px 20px;
			border: 1px solid #2E90F4;
			width: 92px;	
		}
		.renew-btn:hover {
			color: #fff;
			background: RGBA(46, 144, 244, 0.8);
		}
		.utf8-btn {
			background: #2E90F4;
			float: right;
			border-radius: 2px;
			color: #fff;
			font-size: 14px;
			height: 36px;
			margin: 20px 0px 20px 20px;
			border: 1px solid #2E90F4;
			width: 122px;	
		}
		.utf8-btn:hover {
			color: #fff;
			background: RGBA(46, 144, 244, 0.8);
		}
		.import-btn {
			background: #2E90F4;
			float: right;
			border-radius: 2px;
			color: #fff;
			font-size: 14px;
			height: 36px;
			margin-top: 20px;
			border: 1px solid #2E90F4;
			width: 92px;	
		}
		.import-btn:hover {
			color: #fff;
			background: RGBA(46, 144, 244, 0.8);
		}
	}
</style>


// WEBPACK FOOTER //
// AccountUpdate.vue?05a41cf8